import React from 'react';

import {
  BOOKING,
  LOYALTY_CARDS,
  SHOWTIMES_EXPERIENCE
} from 'common/constants/Showtimes';
import { ShowtimeFilterButtonTracking } from 'common/constants/trackingEventsNames';
import trans from 'common/tools/translations/trans';

import FilterDropdown from 'website/components/showtimes/FilterDropdown';
import {
  FilterItem,
  FilterRewritten,
  FiltersRewritten,
  OnFilterChange
} from 'website/components/showtimes/PageFilters';

import FilterSelect from './FilterSelect';

type FilterDropdownSeeMoreProps = {
  filters: FiltersRewritten;
  onFilterChange: OnFilterChange;
  tracking: ShowtimeFilterButtonTracking;
};
const FilterDropdownSeeMore = ({
  filters,
  onFilterChange,
  tracking
}: FilterDropdownSeeMoreProps) => {
  const computeExtraProps = (items: FilterRewritten[]) => {
    let activeItemCount = 0;
    let firstItemLabel: string | undefined;
    let noItems = true;

    items.forEach(filterModel => {
      const hasValues = filterModel.values.length;
      if (noItems && hasValues) {
        noItems = false;
      }

      filterModel.values.forEach(filterValueModel => {
        if (filterValueModel.active) {
          activeItemCount += 1;

          if (!firstItemLabel) {
            firstItemLabel = filterValueModel.label;
          }
        }
      });
    });

    return { activeItemCount, firstItemLabel, noItems };
  };

  // list of data models with props for component <FilterSelect />
  const items: FilterRewritten[] = [];

  // add to the "see more" dropdown the Experiences section if some results
  if (
    filters[SHOWTIMES_EXPERIENCE] &&
    filters[SHOWTIMES_EXPERIENCE].values.length
  ) {
    items.push(filters[SHOWTIMES_EXPERIENCE]);
  }

  if (filters[BOOKING] && filters[BOOKING].values.length) {
    items.push({ ...filters[BOOKING], label: '' });
  }

  if (filters[LOYALTY_CARDS] && filters[LOYALTY_CARDS].values.length) {
    items.push(filters[LOYALTY_CARDS]);
  }

  return (
    <FilterDropdown
      computeExtraProps={computeExtraProps.bind(this, items)}
      items={items}
      nullLabel={trans('showtimes.filters.more_filters')}
      itemLength={
        items.reduce<Array<FilterItem>>(
          (acc, item) => [...acc, ...item.values],
          []
        ).length ?? 0
      }
    >
      {filterModels =>
        filterModels?.map(filterModel => {
          return (
            <FilterSelect
              key={filterModel.label}
              list={filterModel.values}
              onFilterChange={onFilterChange}
              title={filterModel.label}
              tracking={tracking}
            />
          );
        })
      }
    </FilterDropdown>
  );
};

export default FilterDropdownSeeMore;
